import Vue from 'vue'
import ElementUI from 'element-ui';
import { message } from '@/utils/resetMessage'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import Cookies from 'js-cookie'
import 'font-awesome/css/font-awesome.css'
import hasPermission from '@/utils/has.js'
import hashidePermission from '@/utils/hashide.js'
import vuescroll from 'vuescroll';
import * as echarts from 'echarts'

Vue.component('el-image-viewer', ElementUI.Image.components.ImageViewer)

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.use(ElementUI);
ElementUI.Dialog.props.lockScroll.default = false; // 打开弹窗防止页面抖动
Vue.prototype.$message = message

Vue.use(hasPermission);
Vue.use(hashidePermission);

Vue.use(vuescroll); // install the vuescroll first
Vue.prototype.$vuescrollConfig = {
  bar: {
    background: '#000'
  }
};

Vue.prototype.$echarts = echarts


new Vue({
  el:'#app',
  router,
  store,
  render: h => h(App),
  beforeCreate(){
	  Vue.prototype.$bus = this;//创建总线
  }
})
